import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppHttpClient } from './http.client';

@Injectable({
  providedIn: "root",
})
export class ProjectsService {
  constructor(private http: AppHttpClient) { }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(`project/getAll`);
  }

  getRoleProjects(role: string): Observable<string[]> {
    return this.http.get<any[]>(
      `project/get-role-projects?roleName=${role}`
    );
  }
}
